module.exports = __webpack_public_path__ + "static/media/Where3.2a177ed0.jpeg";